import { create } from "zustand";
import { IUserEvent } from "@/types/user.types";
import selectColorTypeEvent from "@/components/common/selectColorTypeEvent";

export const useUserEvent = create<IUserEvent>((set) => ({
  data: {
    name: "",
    hours_type: "24 h",
    sharing: "0",
    dynamic: "1",
    isShowTimeOptions: false,
    design_colors_primary: selectColorTypeEvent[0].color,
    design_colors_button: selectColorTypeEvent[0].buttonColor,
    image: "",
    image_name: "",
    image_type: "",
    image_path: "",
    organizer: "",
    title: "",
    summary: "",
    button: "",
    button_url: "",
    start_date: "",
    end_date: "",
    venue_amenities: [],
    about: "",
    contact: "",
    end_date_time: "23:00",
    start_date_time: "00:00",
    venue_name: "",
    longitude: -73.9855426,
    latitude: 40.7579747,
    address: "",
    street: "",
    street_number: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    timezone: "",
    phone: "",
    email: "",
    website: "",
    welcome_screen: "",
    welcome_path: "",
    showButton: false,
    showMoreAddress: false,
    allDay: false,
    timeType: null,
  },
  config: {},
  addButton: [
    {
      value: "Book now",
      icon: "",
    },
    {
      value: "Get tickets",
      icon: "",
    },
    {
      value: "Register",
      icon: "",
    },
    {
      value: "Custom",
      icon: "/common/edit-icon.svg",
    },
  ],
  allDay: false,
  showMoreContact: false,
  destroyEvent: () =>
    set(() => ({
      data: {
        name: "",
        hours_type: "24 h",
        sharing: "0",
        dynamic: "1",
        isShowTimeOptions: false,
        design_colors_primary: selectColorTypeEvent[0].color,
        design_colors_button: selectColorTypeEvent[0].buttonColor,
        image: "",
        image_name: "",
        image_type: "",
        image_path: "",
        organizer: "",
        title: "",
        summary: "",
        button: "",
        button_url: "",
        start_date: "",
        end_date: "",
        venue_amenities: [],
        about: "",
        contact: "",
        end_date_time: "23:00",
        start_date_time: "00:00",
        venue_name: "",
        longitude: -73.9855426,
        latitude: 40.7579747,
        address: "",
        street: "",
        street_number: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        timezone: "",
        timeType: null,
        phone: "",
        email: "",
        website: "",
        welcome_screen: "",
        welcome_path: "",
        showButton: false,
        showMoreAddress: false,
        allDay: false,
      },
      config: {},
      addButton: [
        {
          value: "Book now",
          icon: "",
        },
        {
          value: "Get tickets",
          icon: "",
        },
        {
          value: "Register",
          icon: "",
        },
        {
          value: "Custom",
          icon: "/common/edit-icon.svg",
        },
      ],
      allDay: false,
      showMoreContact: false,
    })),
  setConfig: (val) =>
    set((state) => ({
      ...state,
      config: { ...state.config, val },
    })),
  setDeleteUserImage: (val) => {
    set((state) => {
      state.data.image = val;

      return { ...state };
    });
  },
  setUserParams: (val) => {
    set((state) => {
      return { ...state, data: { ...state.data, ...val } };
    });
  },
  setShowButton: (val) => {
    set((state) => {
      return { ...state, data: { ...state.data, showButton: val } };
    });
  },
  setUserEventDelete: (val) => {
    set((state) => {
      delete state.data[val];

      return { ...state };
    });
  },
  setHoursType: (val) => {
    set((state) => {
      return { ...state, hours_type: val };
    });
  },
  setShowAllDay: (val) => {
    set((state) => {
      return {
        ...state,
        data: {
          ...state.data,
          allDay: val,
        },
      };
    });
  },
  setShowMoreAddress: (val) => {
    set((state) => {
      return {
        ...state,
        data: {
          ...state.data,
          showMoreAddress: val,
          address: val ? "" : state.data.address,
        },
      };
    });
  },
  setShowMoreContact: (val) => {
    set((state) => {
      return { ...state, showMoreContact: val };
    });
  },
  setAmenties: (val) => {
    set((state) => {
      if (state.data.venue_amenities.find((e) => e.type === val.type) === undefined) {
        return {
          ...state,
          data: {
            ...state.data,
            venue_amenities: [...state.data.venue_amenities, val],
          },
        };
      } else {
        const filtered = state.data.venue_amenities.filter((e) => e.type !== val.type);
        return {
          ...state,
          data: {
            ...state.data,
            venue_amenities: filtered,
          },
        };
      }
    });
  },
}));
